/**
 * Sawaaro shared variant-selection logic.
 *
 * Given a root element containing:
 *  - one <fieldset> per option (Colour, Size, ...) with radio inputs
 *  - a <form> with a hidden input[name="id"] (the variant id to submit)
 *  - .price-now / .price-was / .price-off elements
 *  - a .add-to-bag submit button
 *
 * ...this keeps the hidden variant id, price, and button state in sync
 * with whatever combination of options is currently selected.
 *
 * Used by:
 *  - sections/main-product-sawaaro.liquid (the real product page)
 *  - assets/sawaaro-quick-add.js (the card "Add to cart" popup, which
 *    injects a fetched copy of the same .info markup into a modal)
 */
(function () {
  if (window.SawaaroVariantSelect) return;

  function money(cents) {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  }

  window.SawaaroVariantSelect = function (root, variants) {
    if (!root || !variants || !variants.length) return null;
    // Already wired up (e.g. by the product section AND the auto-init below)?
    // Reuse it instead of attaching a second set of listeners.
    if (root.__sawaaroVariantUpdate) return root.__sawaaroVariantUpdate;

    var form = root.querySelector('form');
    var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    var priceNow = root.querySelector('.price-now');
    var priceWas = root.querySelector('.price-was');
    var priceOff = root.querySelector('.price-off');
    var addBtn = root.querySelector('.add-to-bag');
    var fieldsets = root.querySelectorAll('fieldset');

    function getSelectedOptions() {
      var selected = [];
      fieldsets.forEach(function (fs) {
        var checked = fs.querySelector('input[type="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    function findMatchingVariant() {
      var selected = getSelectedOptions();
      var matches = variants.filter(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        return selected.every(function (val, i) {
          return val === null || opts[i] === val;
        });
      });
      return matches[0] || null;
    }

    function update() {
      // live label text, e.g. "Size — 30"
      fieldsets.forEach(function (fs) {
        var labelSpan = fs.querySelector('.option-label-value');
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (labelSpan && checked) {
          var optionName = labelSpan.getAttribute('data-option-name');
          labelSpan.textContent = optionName + ' — ' + checked.value;
        }
      });

      var variant = findMatchingVariant();

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWas.textContent = money(variant.compare_at_price);
          priceWas.style.display = '';
          if (priceOff) {
            priceOff.textContent =
              Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) +
              '% OFF';
            priceOff.style.display = '';
          }
        } else {
          priceWas.style.display = 'none';
          if (priceOff) priceOff.style.display = 'none';
        }
      }

      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }

      root.dispatchEvent(
        new CustomEvent('sawaaro:variant-change', {
          bubbles: true,
          detail: { variant: variant },
        })
      );
    }

    fieldsets.forEach(function (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', update);
      });
    });

    // Safety net: right before the form is sent, make sure the hidden
    // variant id matches the size/colour that is actually ticked.
    if (form) form.addEventListener('submit', update, true);

    update(); // sync initial state on load
    root.__sawaaroVariantUpdate = update;
    return update;
  };

  // The product section calls SawaaroVariantSelect from an inline script,
  // but this file loads with `defer`, so on the product page it usually
  // isn't ready yet at that moment. When that happens the size buttons were
  // never connected and every "Add to Bag" sent the default variant (30C).
  // Wire the product page up here as soon as this file is available.
  function autoInitProductPage() {
    var dataEl = document.getElementById('SawaaroVariantsJSON');
    var form = document.getElementById('SawaaroProductForm');
    if (!dataEl || !form) return;
    var root = form.closest('.info') || form.parentElement;
    try {
      window.SawaaroVariantSelect(root, JSON.parse(dataEl.textContent));
    } catch (e) { /* leave the page usable even if the JSON is odd */ }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitProductPage);
  } else {
    autoInitProductPage();
  }
})();